<template>
  <div class="home">
    <div class="add-edge" @click="showAddEdgeDialog">
      添加区域
    </div>
    <div class="edge-container">
      <div class="edge-wrapper" v-for="(edge,index) in edgeList" :key="edge.edgeName">
        <!--        区域信息-->
        <div class="edge-header">
          <div class="header-placeholder">
            <div >F0: {{ edge.f0 }}; F1: {{edge.f1}}</div>
            <div >offsetX: {{ edge.offset[0] }}; offsetY: {{edge.offset[1]}}</div>
          </div>
          <div class="edge-info-wrapper">
            <div class="edge-name">
              {{ edge.edgeName }}
            </div>
            <div class="edge-info">
              <div class="edge-imei">IMEI: {{ edge.imei }} </div>
            </div>



          </div>
          <div class="add-station-wrapper">
            <el-button type="primary" size="small" @click="showSetStationRate(index)" v-if="false">设置标签频率</el-button>
            <el-button type="primary" size="small" @click="showAddStationDialog(index)">添加基站</el-button>
          </div>
        </div>

        <!--        station info-->
        <!--        :class="{'station-master':station.isMasterStation}"-->
        <div class="station-container">
          <div class="station-wrapper" v-for="station in edge.stations" :key="station.address">
            <div class="station-name">
              <div>
                基站 {{ station.address }} <span v-show="station.isMasterStation">主站</span>
              </div>
              <div>
                坐标: x:{{station.coords[0]}} y:{{station.coords[1]}} z:{{station.coords[2]}}
              </div>

            </div>
            <div class="system-param-wrapper">

              <div class="station-status"></div>

              <div class="wav-index">目标声波文件索引:
                <el-select v-model="station.wavIndex" size="mini" placeholder="">
                  <el-option v-for="item in wavFileIndexArray" :key="item"
                             :label="item" :value="item">

                  </el-option>
<!--                  <el-option label="1" :value="1"></el-option>-->
<!--                  <el-option label="2" :value="2"></el-option>-->
<!--                  <el-option label="3" :value="3"></el-option>-->
<!--                  <el-option label="4" :value="4"></el-option>-->
<!--                  <el-option label="5" :value="5"></el-option>-->

                </el-select>

              </div>
              <div class="left-vol">右声道音量:
                <el-input v-model="station.leftVol" size="mini"></el-input>
              </div>
              <div class="right-vol">左声道音量:
                <el-input v-model="station.rightVol" size="mini"></el-input>
              </div>
              <div class="sync-delay">同步播放延时:
                <el-input v-model="station.syncDelay" size="mini"></el-input>
              </div>
              <div class="lora-net-address">Lora 网络地址:
                <el-input v-model="station.loraNetAddress" size="mini" maxlength="8"></el-input>
              </div>
              <div class="lora-channel">Lora 通道:
                <el-select v-model="station.loraChannel" size="mini" placeholder="">
                  <el-option label="0" :value="0"></el-option>
                  <el-option label="1" :value="1"></el-option>
                  <el-option label="2" :value="2"></el-option>
                  <el-option label="3" :value="3"></el-option>
                  <el-option label="4" :value="4"></el-option>
                  <el-option label="5" :value="5"></el-option>
                  <el-option label="6" :value="6"></el-option>
                  <el-option label="7" :value="7"></el-option>
                  <el-option label="8" :value="8"></el-option>
                </el-select>
              </div>
              <div class="station-address">
                  基站地址:<el-input v-model="station.stationAddress" size="mini"></el-input>
              </div>
              <div class="station-opt">
                <div>
                  <el-button type="primary" size="mini" @click="setIDLE(edge.imei,station)">IDLE</el-button>
                  <el-button type="primary" size="mini" @click="setStationReset(edge.imei,station)">复位</el-button>
                  <el-button type="primary" size="mini" @click="readStationInfo(edge.imei,station)">读取</el-button>
                  <el-button type="primary" size="mini" @click="setStationParam(edge.imei,station)">设置</el-button>
                </div>
              </div>
              <div class="setting-wrapper">
                <el-button style="margin-top: 10px;" type="primary" size="mini" @click="alert(edge.imei,station)">一键报警</el-button>
                <el-button style="margin-top: 10px;" type="primary" size="mini" @click="restore(edge.imei,station)">一键还原</el-button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>


    <el-dialog class="add-edge-dialog"
               title="添加区域" :visible.sync="isShowAddEdgeInfoDialog"
               :show-close="false" center width="500px" >
      <el-form :model="mqttEdgeInfoArea" >
        <el-form-item label="area" label-width="50px">
          <el-input v-model="mqttEdgeInfoArea.addrEdge"></el-input>
        </el-form-item>
        <el-form-item label="F0" label-width="50px">
          <el-input v-model="mqttEdgeInfoArea.f0"></el-input>
        </el-form-item>
        <el-form-item label="F1" label-width="50px">
          <el-input v-model="mqttEdgeInfoArea.f1"></el-input>
        </el-form-item>

        <el-form-item label="x 轴偏移:" label-width="100px">
          <el-input placeholder="" v-model="mqttEdgeInfoArea.offset[0]">
            <template slot="append">米</template>
          </el-input>

        </el-form-item>

        <el-form-item label="y 轴偏移:" label-width="100px">
          <el-input placeholder="" v-model="mqttEdgeInfoArea.offset[1]">
            <template slot="append">米</template>
          </el-input>
        </el-form-item>


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleAddEdge" style="width: 45%">修改</el-button>
        <el-button type="primary" @click="handleNotModify" style="width: 45%">不修改</el-button>
      </div>

    </el-dialog>


    <el-dialog class="add-station-dialog"
               title="添加基站" :visible.sync="isShowAddStation"
               :show-close="false" center width="700px">
      <div class="station-info-wrapper">
        <div class="station-item" v-for="(stationInfo,index) in stationInfos" :key="index">
          <span>address: </span>
          <el-input class="station-aid" placeholder="aid" v-model.number="stationInfo.address">
          </el-input>
          <span>x 轴: </span>
          <el-input class="station-x" placeholder="x轴坐标" v-model="stationInfo.coords[0]">
            <template slot="append">米</template>
          </el-input>
          <span>y 轴: </span>
          <el-input placeholder="y轴坐标" v-model="stationInfo.coords[1]">
            <template slot="append">米</template>
          </el-input>
          <span>z 轴: </span>
          <el-input placeholder="z轴坐标" v-model="stationInfo.coords[2]">
            <template slot="append">米</template>
          </el-input>
        </div>

        <div class="station-item">
          <el-button  icon="el-icon-minus" @click="removeStationInfo" style="width: 45%">remove</el-button>
          <el-button  icon="el-icon-plus" @click="addStationInfo" style="width: 45%">Add</el-button>
        </div>

        <div slot="footer" class="dialog-footer station-item">
          <el-button type="primary" @click="handleAddStation" style="width: 45%">修改</el-button>
          <el-button type="primary" @click="handleNotModifyStation" style="width: 45%">不修改</el-button>
        </div>
      </div>

    </el-dialog>


  </div>
</template>

<script>
// @ is an alias to /src
import mqtt from "mqtt"
import StringUtils from "../utils/StringUtils"
import {MsgType} from "@/utils/MsgType";
import {v4 as uuidv4} from "uuid";
import {Message} from "element-ui";
import CmdUtils from '../utils/CmdUtils'


function Edge(edgeName,imei,f0,f1,offset,stations) {
  this.edgeName = edgeName;
  this.imei = imei;
  this.f0 = f0;
  this.f1 = f1;
  this.offset = offset;
  this.stations = stations;
}

function Station(edgeIndex,address,wavIndex ,rightVol,leftVol,syncDelay,loraNetAddress,loraChannel,stationAddress ,coords,isMasterStation) {
  this.edgeIndex = edgeIndex
  this.address = address;
  this.wavIndex = wavIndex;
  this.rightVol = rightVol;
  this.leftVol = leftVol;
  this.syncDelay = syncDelay;
  this.loraNetAddress = loraNetAddress;
  this.loraChannel = loraChannel;
  this.stationAddress = stationAddress;
  this.isMasterStation = isMasterStation;
  this.coords = coords

}

export default {
  name: 'MapController',
  components: {},
  data() {
    return {
      edgeInfo: new Edge("区域","866250069400764",16000,17000,[],[]),
      edgeList: [
          // Edge
      ],
      client: null,
      isShowAddEdgeInfoDialog: false,
      isShowAddStation: false,
      isShowSetStationRate:false,
      stationInfoList: [
        // {
        //   imei: "",
        //   stationInfo:[{
        //     aid: 0,
        //     address:0,
        //     coords: [0, 0, 0],
        //   },]
        // },
      ],
      currentEdgeIndex: 0,
      arera: 1,
      mqttEdgeInfoArea: {
        addrEdge: "",
        imei: "",
        f0: 0,
        f1: 0,
        offset:[0,0], //x y 的偏移  当前原点 距 原点
      },
      loading: null,
      isActiveGetArea: false,
      isActiveGetAxis: false,
      cmdTimeoutId: null,
      imeis:[],
      currentImei: "866250069400764",//"866250069400723",
      isContinousSetting: false,
      wavFileIndexArray:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16],
      mqttHost: "ws://47.118.36.78",
      mqttPort: "8083",
      mqttPath: "mqtt",
      username: "xuxingguo",
      password: "Xgw19931010",

    }
  },
  computed: {
    stationInfos() {
      // if (this.stationInfoList.length === 0){
      //   return []
      // }else {
      //   return this.stationInfoList[this.currentEdgeIndex].stationInfo;
      // }
      if (this.stationInfoList[this.currentEdgeIndex]?.stationInfo === undefined) {
        return []
      }else {
        return this.stationInfoList[this.currentEdgeIndex].stationInfo
      }
    }
  },
  mounted() {
    console.log("mounted");
    this.connect();
  },
  destroyed() {
    console.log("destroyed");
    if (this.client) {
      this.client.end();
    }
  },
  methods: {

    connect() {
      let that = this;
      let clientId = uuidv4();
      console.log("clientId = "+clientId);
      let options = {
        // Clean session
        clean: true,
        connectTimeout: 4000,
        // Auth
        clientId: clientId,
        username: that.username,
        password: that.password,
      }

      // this.client = mqtt.connect("ws://47.118.36.78:8083/mqtt", options);
      this.client = mqtt.connect(`${this.mqttHost}:${this.mqttPort}/${this.mqttPath}`, options);

      this.client.on("connect", (e) => {
        console.log("成功连接服务器:", e);
      });
      this.client.on('message', function (topic, message) {
        // message is Buffer
        // console.log("on message")
        // console.log(message)
        console.log(topic);
        let imei = topic.split("/")[1];
        // that.handleMqttMessage(imei, message)
        CmdUtils.handleMqttMessage(imei,message,that.onMqttData,that.onMqttFailed);
        // that.client.end()
      })
      this.client.on('reconnect', function () {
        console.log('Reconnecting...')
      })
      this.client.on('close', function () {
        console.log('Disconnected')
      })
      this.client.on('disconnect', function (packet) {
        console.log(packet)
      })
      this.client.on('offline', function () {
        console.log('offline')
      })
      this.client.on('error', function (error) {
        console.log(error)
      })

    },

    addStationInfo() {
      // let stationInfoLen = this.stationInfoList[this.currentEdgeIndex].stationInfo.length;
      this.stationInfoList[this.currentEdgeIndex].stationInfo.push({
        aid:0,
        address: 0,
        coords: [0,0,0]
      })
    },
    removeStationInfo() {
      this.stationInfoList[this.currentEdgeIndex].stationInfo.pop();
    },
    findImeiIndex(imei) {
      return this.imeis.findIndex(value => {
        return value === imei;
      })
    },

    showAddEdgeDialog() {
      this.$prompt('请输入 IMEI', '添加区域', {
        confirmButtonText: '下一步',
        cancelButtonText: '取消',
        inputType: 'tel',
        showClose: false,
        inputPlaceholder: '请输入 15 位的 IMEI',
        inputPattern: /^\d{15}$/,
        inputErrorMessage: '请输入 15 位的 IMEI',
        // inputValue: this.currentImei,

      }).then(({ value }) => {
        this.currentImei = value;
        if (this.findImeiIndex(value) === -1) {
          this.imeis.push(value);
        }
        this.subscribe(value);
        // setTimeout(()=>{
        //   this.getEdgeArea();
        // },500);
      }).catch(() => {

      });
    },
    handleAddEdge() {
      this.isShowAddEdgeInfoDialog = false;
      //   let arera = new Uint8Array(StringUtils.hex2Bytes(this.mqttEdgeInfoArea.addrEdge));
      //   let offsetX = new Uint8Array(new Float32Array([this.mqttEdgeInfoArea.offset[0]]).buffer)
      //   let offsetY = new Uint8Array(new Float32Array([this.mqttEdgeInfoArea.offset[1]]).buffer)
      //   let f0 = new Uint8Array(new Uint16Array([this.mqttEdgeInfoArea.f0]).buffer);
      //   let f1 = new Uint8Array(new Uint16Array([this.mqttEdgeInfoArea.f1]).buffer);
      this.publish(this.currentImei, CmdUtils.getSetSysAreaCmd(this.mqttEdgeInfoArea.addrEdge,
          this.mqttEdgeInfoArea.offset[0],this.mqttEdgeInfoArea.offset[1],this.mqttEdgeInfoArea.f0,this.mqttEdgeInfoArea.f1))
    },
    handleNotModify() {
      this.isShowAddEdgeInfoDialog = false;
      let edgeInfo = new Edge("区域"+this.mqttEdgeInfoArea.addrEdge,this.mqttEdgeInfoArea.imei,
          this.mqttEdgeInfoArea.f0,this.mqttEdgeInfoArea.f1,this.mqttEdgeInfoArea.offset,[]);
      let index = this.edgeList.findIndex(value => {
        return value.imei === edgeInfo.imei;
      });
      // console.log(index)
      if (index === -1) {
        this.edgeList.push(edgeInfo);
      }else {
        this.$set(this.edgeList,index,edgeInfo);
      }
    },

    // getSetSysParamCmd() {
    //   let fullArr = [];
    //   let arera = new Uint8Array(StringUtils.hex2Bytes(this.mqttEdgeInfoArea.addrEdge));
    //   let offsetX = new Uint8Array(new Float32Array([this.mqttEdgeInfoArea.offset[0]]).buffer)
    //   let offsetY = new Uint8Array(new Float32Array([this.mqttEdgeInfoArea.offset[1]]).buffer)
    //   let f0 = new Uint8Array(new Uint16Array([this.mqttEdgeInfoArea.f0]).buffer);
    //   let f1 = new Uint8Array(new Uint16Array([this.mqttEdgeInfoArea.f1]).buffer);
    //   fullArr.push(...Array.from(arera),...Array.from(offsetX),...Array.from(offsetY), ...Array.from(f0), ...Array.from(f1))
    //   let cmd = this.getFullCmdBuffer(MsgType.WEB_MSG_SET_ARERA, fullArr);
    //   return cmd;
    // },
    /**
     * 设置基站坐标
     * @returns {Uint8Array}
     */
    // getSetAxisCmd() {
    //   let fullArr = [];
    //   let stationInfos = this.stationInfoList[this.currentEdgeIndex].stationInfo;
    //   for (let i = 0; i < stationInfos.length; i++) {
    //     let aid = new Uint8Array(new Uint32Array([stationInfos[i].aid]).buffer);
    //     let address = new Uint8Array(new Uint32Array([stationInfos[i].address]).buffer);
    //     let coords = new Uint8Array(new Float32Array(stationInfos[i].coords).buffer);
    //     fullArr.push(...Array.from(aid),...Array.from(address), ...Array.from(coords));
    //   }
    //   console.log(fullArr)
    //   return this.getFullCmdBuffer(MsgType.WEB_MSG_SET_EDGE_AXIS, fullArr);
    // },


    /**
     * 设置标签频率
     * @param index
     */
    showSetStationRate(index) {
      // this.currentEdgeIndex = index;
      // this.isShowSetStationRate = true;
      // this.currentImei = this.edgeList[index].imei;
      // this.$prompt("输入标签ID","提示",{
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   inputValue: "",
      // }).then((res)=> {
      //   console.log(res)
      //   let rate = [];
      //   for (let i = 0; i <res.value.length ; i+=2) {
      //     rate.push(parseInt(res.value.slice(i,i+2),16))
      //   }
      //
      //   console.log("rate",rate)
      //   let rateCmd = Array.from(new Uint8Array(rate));
      //   this.publish(this.currentImei,this.getFullCmdBuffer(MsgType.WEB_MSG_SET_LABEL_FREQ,rateCmd));
      //
      // })
    },

    showAddStationDialog(index) {
      // console.log(index)
      this.currentEdgeIndex = index;
      this.currentImei = this.edgeList[index].imei;
      // this.isShowAddStation = true;
      this.getEdgeAxis(this.currentImei);
      // this.edgeList[index].stations.splice(stationLen-2,1)
    },

    handleAddStation() {
      // console.log(`station = ${this.stationInfoList}`);
      this.isShowAddStation = false;
      let stationInfos = this.stationInfoList[this.currentEdgeIndex].stationInfo;
      this.publish(this.currentImei, CmdUtils.getSetAxisCmd(stationInfos));
    },
    handleNotModifyStation() {
      this.isShowAddStation = false;
      let stationInfos = this.stationInfoList[this.currentEdgeIndex].stationInfo;
      let stations = [];
      for (let i = 0; i < stationInfos.length; i++) {
        let station = new Station(this.currentEdgeIndex,stationInfos[i].address);
        station.coords = stationInfos[i].coords;
        stations.push(station);
      }
      // console.log("stations: ")
      // console.log(stations);
      this.edgeList[this.currentEdgeIndex].stations = stations;
      // this.$set(this.edgeList,this.currentEdgeIndex,{
      //
      // })
    },


    readStationInfo(imei,station) {
      this.publish(imei,CmdUtils.getSysParamCmd(station.address));

    },
    setStationParam(imei,station) {
      // let stationInfo = this.edgeList[station.edgeIndex].stations[station.address];
      // let stationInfo = station;
      // console.log(stationInfo)
      // let param = [];
      // let addr = Array.from(new Uint8Array(new Uint32Array([stationInfo.address]).buffer));
      // let fileIndex = Array.from(new Uint8Array([stationInfo.wavIndex])) ;
      // let leftVol = Array.from(new Uint8Array([stationInfo.leftVol]));
      // let rightVol = Array.from(new Uint8Array([stationInfo.rightVol]));
      // let syncDelay = Array.from(new Uint8Array(new Uint16Array([stationInfo.syncDelay]).buffer));
      // let netAddressArr = [];
      // for (let i = 0; i <stationInfo.loraNetAddress.length ; i+=2) {
      //   netAddressArr.push(parseInt(stationInfo.loraNetAddress.slice(i,i+2),16))
      // }
      // let netAddr = Array.from(new Uint8Array(netAddressArr));
      // let deviceAddr = Array.from( new Uint8Array([stationInfo.stationAddress]));
      // let channel = Array.from(new Uint8Array([stationInfo.loraChannel]));
      // param.push(...addr,...fileIndex,...leftVol,...rightVol,...syncDelay,...netAddr,...deviceAddr,...channel);
      // this.publish(imei,this.getFullCmdBuffer(MsgType.WEB_MSG_SET_SYS_PARAM,param));

      this.publish(imei,CmdUtils.getSetSysParamCmd(station.address,station.wavIndex,
          station.leftVol,station.rightVol,station.syncDelay,station.loraNetAddress,station.stationAddress,station.loraChannel))

    },


    setIDLE(imei,station) {
      // let address = new Uint8Array(new Uint32Array([station.address]).buffer);
      this.publish(imei,CmdUtils.getSetIDLEMode(station.address));
    },
    setStationReset(imei,station) {
      // let address = new Uint8Array(new Uint32Array([station.address]).buffer);
      this.publish(imei,CmdUtils.getSetPlayMode(station.address))
    },

    getEdgeAxis(imei) {
      this.publish(imei,CmdUtils.getEdgeAxisCmd())
    },
    getEdgeArea(imei) {
      this.publish(imei,CmdUtils.getEdgeAreaCmd())
    },
    alert(imei, station){
      this.setIDLE(imei,station);
      setTimeout(()=>{
        this.isContinousSetting = true;
        this.readStationInfo(imei,station);
      },2000);
    },
    restore(imei, station){
      this.setIDLE(imei,station);
      setTimeout(()=>{
        this.continuousSettingParams(imei,station,false);
      },2000);
    },

    continuousSettingParams(imei,station,isFixed){
      if (isFixed){
        let target = {...station}
        target.leftVol = 45;
        target.rightVol = 45;
        target.syncDelay = 0;
        target.wavIndex = 2;
        this.setStationParam(imei,target);
      }else {
        this.setStationParam(imei,station);
      }
      setTimeout(()=>{
        this.setStationReset(imei,station);
      },5000);
    },


    subscribe(imei) {
      if (this.client) {
        this.client.subscribe("serialTx/" + imei,{ qos: 0 }, (err) => {
          if (!err) {
            console.log(`订阅 IMEI: ${imei} 成功`)
            this.getEdgeArea(imei);
          }
        })
      }
    },

    publish(imei, msg) {
      if (this.client) {
        this.client.publish("serialRx/" + imei, msg, (err) => {
          if (!err) {
            console.log("发送 mqtt 消息 msgType = "+msg[2].toString(16))
            this.handlePublishSuccess(msg[2])
          } else {
            console.log(err)
            Message.error("发送指令失败")
            this.closeLoading()

          }
        })
      }
    },
    handlePublishSuccess(msgType) {
      switch (msgType) {
        case MsgType.WEB_MSG_SET_SYS_PARAM:
          this.showLoading("设置基站参数中...")
          break;
        case MsgType.WEB_MSG_SET_IDLE_MODE:
          this.showLoading("设置基站为 IDLE 模式...")
          break;
        case MsgType.WEB_MSG_SET_EDGE_AXIS:
          this.showLoading("设置边缘服务器坐标参数...")
          break
        case MsgType.WEB_MSG_GET_EDGE_AXIS:
          this.isActiveGetAxis = true;
          this.showLoading("读取边缘服务器坐标参数...")
          break
        case MsgType.WEB_MSG_SET_AREA:
          this.showLoading("设置边缘服务器区域信息...")
          break
        case MsgType.WEB_MSG_GET_AREA:
          this.isActiveGetArea = true;
          this.showLoading("读取边缘服务器区域信息...")
          break
        case MsgType.WEB_MSG_GET_SYS_PARAM:
          this.showLoading("读取基站参数...")
          break
        case MsgType.WEB_MSG_SET_PLAY_MODE:
          this.showLoading("复位基站...")
          break;
        case MsgType.WEB_MSG_SET_LABEL_FREQ:
          this.showLoading("正在设置标签频率...")
          break

      }
    },


    parsePos(imei,message) {
      let labelId = StringUtils.bytes2Hex(message.slice(0,4).reverse());
      let addrEdge = StringUtils.bytes2Hex( message.slice(4,8).reverse());
      let x = new Float32Array(new Uint8Array([message[8],message[9],message[10],message[11]]).buffer)[0];
      let y = new Float32Array(new Uint8Array([message[12],message[13],message[14],message[15]]).buffer)[0];
      let z = new Float32Array(new Uint8Array([message[16],message[17],message[18],message[19]]).buffer)[0];
      console.log(`labelId = ${labelId} addrEdge = ${addrEdge} x = ${x} y = ${y} z = ${z}`);
    },
    handleEdgeAxis(imei, stationInfo) {
      let index = this.stationInfoList.findIndex(value => {
        return value.imei === imei;
      })
      if (index === -1) {
        this.stationInfoList.push({
          imei: imei,
          stationInfo: []
        })
        index = this.stationInfoList.findIndex(value => {
          return value.imei === imei;
        })
      }else {
        this.stationInfoList[index].stationInfo.splice(0);
      }
      this.$set(this.stationInfoList,index,{
        imei,
        stationInfo
      })
      if (this.isActiveGetAxis) {
        this.isShowAddStation = true;
        this.isActiveGetAxis = false;
      }
    },
    handleEdgeArea(imei, edgeAreaInfo) {

      this.mqttEdgeInfoArea.addrEdge = edgeAreaInfo.addrEdge;
      this.mqttEdgeInfoArea.f0 = edgeAreaInfo.f0;
      this.mqttEdgeInfoArea.f1 = edgeAreaInfo.f1;
      this.mqttEdgeInfoArea.imei = imei;
      this.mqttEdgeInfoArea.offset = [parseFloat(edgeAreaInfo.offsetX),parseFloat(edgeAreaInfo.offsetY)];
      if (this.isActiveGetArea) {
        this.isShowAddEdgeInfoDialog = true;
        this.isActiveGetArea = false;
      }
    },

    handleMqttMessage(imei,msg) {
      this.closeLoading();
      console.log(msg)
      if (msg[0] === 0xE7 && msg[1] === 0xCC) {
        let msgType = msg[2];
        let respType = msg[3];
        let msgLen = new Uint16Array([msg[4],msg[5]])[0];
        let message = [];
        if (msgLen !== 0) {
          message = msg.slice(6,msg.length-2);
          // console.log("message: ")
          // console.log(message);
        }
        console.log(`收到mqtt消息 ${StringUtils.bytes2Hex(msgType)}`)
        if (msgType === MsgType.WEB_MSG_OK) {//发送成功
          // console.log(`publish ${respType.toString(16)} success`)
          switch (respType) {
            case MsgType.WEB_MSG_SET_AREA: //设置边缘服务器的区域信息，每个区域对应一组音频频率
              // console.log("add edge success");
              let edgeInfo = new Edge("区域"+this.mqttEdgeInfoArea.addrEdge,this.mqttEdgeInfoArea.imei,
                  this.mqttEdgeInfoArea.f0,this.mqttEdgeInfoArea.f1,this.mqttEdgeInfoArea.offset,[]);
              // console.log(edgeInfo)
              let index = this.edgeList.findIndex(value => {
                return value.imei === edgeInfo.imei;
              });
              if (index === -1) {
                this.edgeList.push(edgeInfo);
              }else {
                this.$set(this.edgeList,index,edgeInfo);
              }
              Message.success("设置区域信息成功")
              // this.getEdgeAxis();
              // this.getEdgeArea();
              break;
            case MsgType.WEB_MSG_SET_EDGE_AXIS: //设置边缘服务器坐标的参数
              // console.log("add station success")
              Message.success("设置坐标参数成功")
              // let stationInfos = this.stationInfoList[this.currentEdgeIndex].stationInfo;
              // let stations = [];
              // for (let i = 0; i < stationInfos.length; i++) {
              //   let station = new Station(this.currentEdgeIndex,stationInfos[i].address);
              //   station.coords = stationInfos[i].coords
              //   stations.push(station);
              // }
              // this.edgeList[this.currentEdgeIndex].stations = stations;
              let stationInfos = this.stationInfoList[this.currentEdgeIndex].stationInfo;
              let stations = [];
              for (let i = 0; i < stationInfos.length; i++) {
                let station = new Station(this.currentEdgeIndex,stationInfos[i].address);
                station.coords = stationInfos[i].coords;
                stations.push(station);
              }
              // console.log("stations: ")
              // console.log(stations);
              this.edgeList[this.currentEdgeIndex].stations = stations;
              this.$forceUpdate();
              break;
            case MsgType.WEB_MSG_GET_SYS_PARAM: //获取系统设置参数
              if (message.length > 0){
                let address = new Uint32Array(message.slice(0,4))[0];
                let playFileIndex = new Uint8Array([message[4]])[0];
                let leftVol = new Uint8Array([message[5]])[0];
                let rightVol = new Uint8Array([message[6]])[0];
                let syncDelay = new Uint16Array(new Uint8Array([message[7],message[8]]).buffer)[0];
                let loraNetAddress = StringUtils.bytes2Hex(message.slice(9,13).reverse());// message[12].toString(16) + message[11].toString(16) + message[10].toString(16) + message[9].toString(16);
                let deviceAddress = new Uint8Array([message[13]])[0];
                let channel = new Uint8Array([message[14]])[0];
                let station = new Station(this.currentEdgeIndex,address,playFileIndex,rightVol,leftVol,syncDelay,loraNetAddress,
                    channel,deviceAddress,[],address === 0);
                // console.log(station);
                let index = this.edgeList[this.currentEdgeIndex].stations.findIndex(value => {
                  return value.address === address;
                })
                // console.log("index = "+index)
                if (index !== -1) {
                  this.$set(this.edgeList[this.currentEdgeIndex].stations,index,station)
                }else {
                  this.edgeList[this.currentEdgeIndex].stations.push(station);
                }
                if (this.isContinousSetting) {
                  this.isContinousSetting = false;
                  this.continuousSettingParams(imei,station,true);
                }
              }
              // this.$forceUpdate();
              Message.success("获取系统参数成功");

              break;
            case MsgType.WEB_MSG_SET_SYS_PARAM:
              console.log("set system param success");
              Message.success("设置基站参数成功");
              break;
            case MsgType.WEB_MSG_SEND_POS:
              if (message.length > 0){
                this.parsePos(imei,message);
              }
              break;
            case MsgType.WEB_MSG_GET_EDGE_AXIS:

                this.handleEdgeAxis(imei,message);
                // this.getEdgeArea()

              break;
            case MsgType.WEB_MSG_GET_AREA:
              if (message.length > 0){
                this.handleEdgeArea(imei,message);
              }
              break;
          }

        }else if (msgType === MsgType.WEB_MSG_FAILED){ //发送失败
          console.log(`${respType.toString(16)} failed`)
          Message.error(`${respType.toString(16)} failed`);

          if (respType === MsgType.WEB_MSG_GET_EDGE_AXIS) {
            this.isActiveGetAxis = false;
          }else if (respType === MsgType.WEB_MSG_GET_AREA) {
            this.isActiveGetArea = false;
          }

        }

      }
    },

     onMqttData(imei,msgType,data){
      this.closeLoading();
       console.log(`收到mqtt消息 ${msgType.toString(16)}`)
      switch (msgType) {
        case MsgType.WEB_MSG_SET_AREA: //设置边缘服务器的区域信息，每个区域对应一组音频频率
          console.log("add edge success");
          let edgeInfo = new Edge("区域"+this.mqttEdgeInfoArea.addrEdge,this.mqttEdgeInfoArea.imei,
              this.mqttEdgeInfoArea.f0,this.mqttEdgeInfoArea.f1,this.mqttEdgeInfoArea.offset,[]);
          console.log(edgeInfo)
          let index = this.edgeList.findIndex(value => {
            return value.imei === edgeInfo.imei;
          });
          if (index === -1) {
            this.edgeList.push(edgeInfo);
          }else {
            this.$set(this.edgeList,index,edgeInfo);
          }
          Message.success("设置区域信息成功")
          break;
        case MsgType.WEB_MSG_SET_EDGE_AXIS: //设置边缘服务器坐标的参数
          console.log("add station success")
          Message.success("设置坐标参数成功")
          let stationInfos = this.stationInfoList[this.currentEdgeIndex].stationInfo;
          let stations = [];
          for (let i = 0; i < stationInfos.length; i++) {
            let station = new Station(this.currentEdgeIndex,stationInfos[i].address);
            station.coords = stationInfos[i].coords;
            stations.push(station);
          }
          console.log(stations);
          this.edgeList[this.currentEdgeIndex].stations = stations;
          this.$forceUpdate();
          break;
        case MsgType.WEB_MSG_GET_SYS_PARAM: //获取系统设置参数
            if (data != null){
              let station = new Station(this.currentEdgeIndex,data.address,data.playFileIndex,data.rightVol,
                  data.leftVol,data.syncDelay,data.loraNetAddress,
                  data.channel,data.deviceAddress,[],data.address === 0);
              console.log(station);
              let index = this.edgeList[this.currentEdgeIndex].stations.findIndex(value => {
                return value.address === data.address;
              })
              console.log("index = "+index)
              if (index !== -1) {
                this.$set(this.edgeList[this.currentEdgeIndex].stations,index,station)
              }else {
                this.edgeList[this.currentEdgeIndex].stations.push(station);
              }
              if (this.isContinousSetting) {
                this.isContinousSetting = false;
                this.continuousSettingParams(imei,station,true);
              }

              // this.$forceUpdate();
              Message.success("获取系统参数成功");
            }

          break;
        case MsgType.WEB_MSG_SET_SYS_PARAM:
          console.log("set system param success");
          Message.success("设置基站参数成功");
          break;
        case MsgType.WEB_MSG_SEND_POS:
          console.log(data);
          break;
        case MsgType.WEB_MSG_GET_EDGE_AXIS:
          this.handleEdgeAxis(imei,data);
          break;
        case MsgType.WEB_MSG_GET_AREA:
          this.handleEdgeArea(imei,data);
          break;
        case MsgType.WEB_MSG_SET_IDLE_MODE:
          Message.success("设置IDLE成功");
          break
        case MsgType.WEB_MSG_SET_PLAY_MODE:
          Message.success("复位成功");
          break
      }



    },
    onMqttFailed(){

    },


    showLoading(msg) {
      this.loading = this.$loading({
        lock: true,
        text: msg,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.startCmdTimeout();
    },
    closeLoading() {
      this.removeCmdTimeout();
      if (this.loading) {
        this.loading.close();
      }
    },
    startCmdTimeout() {
      this.cmdTimeoutId = setTimeout(()=>{
        this.closeLoading();
        Message.error("操作超时");
      },10000);
    },

    removeCmdTimeout() {
      clearTimeout(this.cmdTimeoutId)
    },


  },



}
</script>
<style lang="scss" scoped>
.home {
  display: flex;
  flex-direction: column;
  width: 1200px;
  margin: 0 auto;

  .add-edge {
    margin-top: 20px;
    height: 80px;
    background-color: #409EFF;
    border-radius: 10px;
    text-align: center;
    font-size: 26px;
    line-height: 80px;
    color: white;
    cursor: pointer;

  }

  .edge-container {
    .edge-wrapper {
      background-color: #f0f9eb;
      margin-top: 20px;
      padding: 20px;
      border-radius: 10px;
      display: flex;
      flex-direction: column;

      .edge-header {
        display: flex;
        background-color: #e1f3d8;
        border-radius: 10px;
        padding: 10px;
        justify-content: space-between;

        .header-placeholder {
          width: 33%;
        }

        .edge-info-wrapper {
          display: flex;
          width: 34%;
          flex-direction: column;

          .edge-name {
            width: 100%;
            font-size: 26px;
            text-align: center;
            color: #303133;
          }

          .edge-info {
            display: flex;
            justify-content: center;
            align-items: center;
            color: #909399;
            flex-direction: column;

            .edge-imei {
            }

            .edge-axis-wrapper {
              align-items: center;
              display: flex;
              margin-left: 10px;

              .edge-aid {
                margin-right: 10px;
              }
            }
          }

        }
        .add-station-wrapper {
          width: 33%;
          text-align: end;
        }
        .add-station {
          width: 100px;
          font-size: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #67C23A;
          color: white;
          border-radius: 10px;
          cursor: pointer;
          /* 火狐 */
          -moz-user-select: none;
          /* Safari 和 欧朋 */
          -webkit-user-select: none;
          /* IE10+ and Edge */
          -ms-user-select: none;
          /* Standard syntax 标准语法(谷歌) */
          user-select: none;

        }
      }

      .station-container {
        display: flex;
        flex-wrap: wrap;

        .station-wrapper {
          margin: 20px 20px 0 0;
          border-radius: 10px;
          background-color: #e1f3d8;
          padding: 10px;
          width: 250px;

          .station-name {
            display: flex;
            justify-content: space-between;
          }

          .system-param-wrapper {

            div {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-top: 2px;
            }

            :deep(.el-input) {
              width: 60px;
            }
            .wav-index {
              :deep(.el-select) {
                width: 60px;
              }
            }
            .lora-net-address {
              :deep(.el-input) {
                width: 120px;
              }
            }
            .station-opt {
              display: flex;
              justify-content: end;
            }

          }

        }
        .station-master {
          margin: 20px 20px 0 0;
          border-radius: 10px;
          background-color: #67C23A;
          padding: 10px;
          width: 250px;
        }
      }


    }
  }

  .add-station-dialog {

    //:deep(.el-dialog) {
    //  width: 540px;
    //}
    //:deep(.el-dialog__header) {
    //  width: 540px;
    //}
    //:deep(.el-dialog__body) {
    //  width: 540px;
    //}
    :deep(.el-dialog__body) {
      padding: 0 !important;
    }
    .station-info-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .station-item {
        margin-top: 10px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        &:last-child {
          width: 100%;
          display: flex;
          justify-content: center;
          margin-bottom: 20px;
        }
      }
      .station-add {
        background-color: skyblue;
        width: 50%;
        text-align: center;
        padding: 10px;
        border-radius: 5px;
        color: white;
        margin: 10px;
      }
      span {
        width: fit-content;
        font-size: 18px;
      }

      :deep(.el-input__inner) {
        width: 70px;
      }
      .el-input {
        width: fit-content;
        margin-right: 20px;
      }

      .station-aid {
        width: fit-content;

        :deep(.el-input__inner) {
          width: 50px;
        }
      }

    }
  }

}

</style>
